import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { TERMS_TEXT } from "./terms";

export default function TermsModal({ open, onClose, onAccept }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>FirstLand Terms & Conditions</DialogTitle>
      <DialogContent dividers sx={{ maxHeight: "60vh", overflowY: "auto" }}>
        {TERMS_TEXT.split("\n\n").map((para, i) => (
          <Typography key={i} paragraph>
            {para}
          </Typography>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onAccept} variant="contained">
          I Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
}
